'use strict';

const CUSTOM_CAPTURE_EVENTS = {
  ACCOUNT_PAGE_ANALYZE_ACCOUNT_BUTTON_CLICK: 'desk-v2:account_page:analyze_account_button_click',
  COMMENT_CONTACT_PAGE_PRIVATE_SUBMIT: 'desk-v2:comment:contact_page:private_comment_submit',
  COMMENT_CONTACT_PAGE_PUBLIC_SUBMIT: 'desk-v2:comment:contact_page:public_comment_submit',
  CONTACT_PAGE_ENGAGE_BUTTON_CLICK: 'desk-v2:engage:contact_page:engage_button_click',
  CONTACT_PAGE_MOBILE_DOWNVOTE: 'desk-v2:contact_page:mobile_downvote',
  CONTACT_PAGE_MOBILE_DOWNVOTE_SUBMIT: 'desk-v2:contact_page:mobile_downvote_submit',
  CONTACT_PAGE_MOBILE_UPVOTE: 'desk-v2:contact_page:mobile_upvote',
  CONTACT_PAGE_SHOW_MOBILE_BUTTON_CLICK: 'desk-v2:contact_page:show_mobile_button_click',
  ENGAGE_PAGE_EMAIL_SUBMIT: 'desk-v2:engage:engage_page:email_submit',
  INQUIRY_ACCOUNT_PAGE_SUBMIT_FROM_HEADER: 'desk-v2:inquiry:account_page:header:account_inquiry_submit',
  INQUIRY_ACCOUNT_PAGE_SUBMIT_FROM_CHART: 'desk-v2:inquiry:account_page:chart:account_inquiry_submit',
  INQUIRY_CONTACT_PAGE_SUBMIT: 'desk-v2:inquiry:contact_page:contact_inquiry_submit',
  INQUIRY_CONTACT_PAGE_MOBILE_SUBMIT: 'desk-v2:inquiry:contact_page:mobile_inquiry_submit',
  NAVBAR_LOGO_CLICKED: 'navbar_logo_clicked',
  PAGELEAVE: '$pageleave',
  PAGEVIEW: '$pageview',
  SEQUENCE_CREATE_WITH_AI_CLICK: 'desk-v2:sequence:create_with_ai_button_click',
  TASK_CHANGE_STATUS: 'desk-v2:task:contact_page:task_change_status',
  TASK_CONTACT_PAGE_ADD_CLICK: 'desk-v2:task:contact_page:task_add_click',
};

export {
  CUSTOM_CAPTURE_EVENTS,
};
